export default __webpack_public_path__ + "static/media/enghien21.015b0077.jpg";